package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class LanguageState(
    val id: String,
    langue: String = "",
    niveau: String = ""
) {
    var langue by mutableStateOf(langue)
    var niveau by mutableStateOf(niveau)
}